<template>
    <table class="table table-sm" :class="classes">
      <thead>
        <slot name="thead" />

        <tr v-if="$slots.thead == null">
          <th
            v-for="coluna in colunas"
            class="pb-4"
            :class="coluna.classes"
            :key="`header-${coluna.nome}`"
            @click="onOrdenar(coluna)"
          >
            {{ coluna.nome }}
            <i
              v-if="coluna.ordenavel"
              class="float-right m-t-5"
              :class="coluna.ordem | iconeOrdenacao"
            ></i>
          </th>
        </tr>
      </thead>

      <tbody>
        <slot name="tbody">
          <template v-if="$slots.tr !== null && itens.length > 0">
            <tr
              v-for="(item, rowIndex) in itens"
              :key="`row-${rowIndex}`"
              :row-id="rowIndex"
            >
              <slot name="tr" :item="item" :index="rowIndex">
                <td
                  v-for="(coluna, colIndex) in colunas"
                  :key="`col-${colIndex}-${coluna.campo}`"
                  :col-id="`col-${colIndex}-${coluna.campo}`"
                  :class="coluna.classes"
                >
                  {{ item[coluna.campo] }}
                </td>
              </slot>
            </tr>
          </template>

          <template v-if="$scopedSlots.tr !== null && itens.length == 0">
            <tr>
              <td :colspan="colunas.length">
                {{ mensagemTabelaVazia }}
              </td>
            </tr>
          </template>
        </slot>
      </tbody>

      <tfoot>
        <slot name="tfoot" />
      </tfoot>
    </table>
</template>
<script>
const ASC = "ASC";
const DESC = "DESC";

export default {
  name: "HcTabela",
  filters: {
    iconeOrdenacao
  },
  props: {
    colunas: {
      type: Array,
      default: () => []
    },
    classes: {
      type: Array,
      default: () => []
    },
    itens: {
      type: Array,
      default: () => []
    },
    mensagemTabelaVazia: {
      type: String,
      default: "Nenhum registro encontrado"
    },
    mantemEstado: {
      type: Boolean,
      default: false
    },
    ordenacao: {
      type: String,
      default: null
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onOrdenar,
    _limparOrdenacao,
    _atualizaEstado,
    _setOrdenacaoFromString
  },
  watch: {
    ordenacao
  },
  mounted: _setupEstadoOrdenacao
};

function onOrdenar(coluna) {
  if (coluna.ordenavel) {
    let ordem = coluna.ordem;

    this._limparOrdenacao();

    if (ordem) {
      ordem = ASC === ordem ? DESC : null;
    } else {
      ordem = ASC;
    }

    coluna.ordem = ordem;

    this._atualizaEstado(coluna);

    this.$emit("ordenar", { campo: coluna.campo, ordem });
  }
}

function ordenacao(ordenacao) {
  this._limparOrdenacao();
  if (ordenacao) {
    this._setOrdenacaoFromString(ordenacao);
  }
  this._atualizaEstado(ordenacao);
}

function iconeOrdenacao(ordemColuna) {
  if (ordemColuna) {
    const ordem = ordemColuna.toUpperCase();
    if (ASC === ordem) {
      return "fa-sort-up";
    } else if (DESC === ordem) {
      return "fa-sort-down";
    }
  }

  return "fa-sort";
}

function _setOrdenacaoFromString(ordem) {
  if (typeof ordem === "string") {
    ordem = ordem.split(/,/);
    const coluna = this.colunas.find(coluna => coluna.campo === ordem[0]);
    coluna.ordem = ordem[1];
  }
}

function _limparOrdenacao() {
  this.colunas.forEach(coluna => (coluna.ordem = null));
}

function _atualizaEstado(ordenacao) {
  if (this.mantemEstado) {
    const query = { ...this.$route.query };

    delete query.ordem;

    if (ordenacao) {
      if (typeof ordenacao === "object" && ordenacao.ordem != null) {
        query.ordem = `${ordenacao.campo},${ordenacao.ordem}`;
      } else if (typeof ordenacao === "string") {
        query.ordem = ordenacao;
      }
    }

    this.$router.replace({ query });
  }
}

function _setupEstadoOrdenacao() {
  if (this.mantemEstado) {
    this.$router.onReady(() => {
      this._setOrdenacaoFromString(this.$route.query.ordem);
    });
  }
}
</script>
